<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="small-medium"
            @close="close"
            v-if="isShowTakeOver">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Rundown Take Over') }}</h5>
            </template>
            <template slot="body">
                <div class="text-center mb-4 mt-4">
                    <img src="/img/account-switch.png" alt="xls" width="70px;"/>
                </div>
                <!-- <div class="text-center">
                    <p class="material-icons-swap text-center">swap_horiz</p>
                </div> -->
                <p class="mb-2 text-center text-base">{{ $t('Another admin is editing this rundown, only one admin is active at one rundown, press Ok to proceed!') }},</p>
                <div class="text-center">
                    <button
                        @click="takeOver"
                        type="submit"
                        class="btn btn-submit btn-primary text-center">
                        {{ $t('Ok') }}
                    </button>
                </div>
            </template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalRundownTakeOver',
	components: {
		Modal,
	},
	props: {
		isShowTakeOver: {
			type: Boolean,
		},
	},
	mounted() {
	},
	data: () => ({
	}),
	methods: {
		close() {
			this.$emit('close');
		},
		takeOver() {
			// @TODO : add take over via socket
			this.$emit('close');
		},
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn',
		}),
	},
};
</script>
